export const fxgBaseApi = '/authorizations/v1/fxg';

export const routes = Object.freeze({
  register: '/register',
  rsvpError: '/rsvp-error',
  error: '/error',
  home: '/home',
  myActions: '/my-actions',
  manageDigitalAssets: '/manage-digital-assets',
  manageContacts: '/manage-contacts',
  userDetails: '/user-details',
});

export const apiPaths = Object.freeze({
  user: `${fxgBaseApi}/user`,
  productEnroll: `${fxgBaseApi}/profile`,
  welcomeAuthenticate: `${fxgBaseApi}/rsvp_cd/validate`,
});
